

export function getFormattedLocalDate(date) {
    if (!date || typeof date !== "string") return "";

    try {
        return new Date(date.slice(0, 23)).toLocaleString("ru-RU", {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch (e) {
        console.error("Ошибка форматирования даты:", e);
        return "";
    }
}